import { render, staticRenderFns } from "./VulnerabilityModal.vue?vue&type=template&id=e8d1f29e&"
import script from "./VulnerabilityModal.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports